import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
import { focusOutline } from '@design-system/theme';
const ICON_PROPORTION = 42;
const LEFT_PADDING_PROPORTION = 6.6;
export const Play = ({ ariaLabel, onClick, size = 48 }) => {
    const iconSize = Number(size) * (ICON_PROPORTION / 100);
    const paddingLeft = Number(size) * (LEFT_PADDING_PROPORTION / 100);
    const a11yText = ariaLabel || __('Start the video preview');
    return (_jsx(Wrapper, { "aria-label": a11yText, "data-testid": "ds-play", height: size, onClick: onClick, onKeyPress: onEnterOrSpacePress(onClick), pl: `${paddingLeft}px`, role: "button", tabIndex: 0, width: size, children: _jsx(FontAwesomeIcon, { color: "white", height: `${iconSize}px`, iconName: "play", iconType: CATEGORIES.SOLID }) }));
};
const Wrapper = styled(Box).attrs(() => ({
    alignItems: 'center',
    bg: 'primary',
    justifyContent: 'center',
})) `
  ${focusOutline}
  cursor: pointer;
  border-radius: 50%;
  user-select: none;
  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primaryDark};
  }
`;
//# sourceMappingURL=Play.js.map